function safeParseEssentials(essentials?: string | null) {
  if (!essentials) {
    return undefined;
  }
  try {
    return JSON.parse(decodeURIComponent(essentials));
  } catch (e) {
    console.warn(
      'Failed to parse "essentials" query parameter. Make sure to run the code inside a supported Wix App extension.',
      e,
    );
    return undefined;
  }
}

export function getEssentialsFromQueryParams(queryParams: URLSearchParams) {
  return queryParams.has('essentials')
    ? safeParseEssentials(queryParams.get('essentials'))
    : undefined;
}
